import type { ButtonHTMLAttributes, JSX } from 'react';

import { cn } from '@/lib/cn.ts';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const BASE =
  'inline-flex min-h-11 items-center justify-center rounded-md px-4 text-sm font-medium ' +
  'transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ' +
  'disabled:cursor-not-allowed disabled:opacity-60';

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-slate-900 text-white hover:bg-slate-800 focus-visible:ring-slate-500',
  secondary:
    'bg-white text-slate-900 border border-slate-200 hover:bg-slate-50 ' +
    'focus-visible:ring-slate-400',
  ghost: 'bg-transparent text-slate-700 hover:bg-slate-100 focus-visible:ring-slate-300',
};

export function Button({
  variant = 'primary',
  className,
  type = 'button',
  children,
  ...rest
}: ButtonProps): JSX.Element {
  return (
    <button type={type} className={cn(BASE, VARIANTS[variant], className)} {...rest}>
      {children}
    </button>
  );
}
